import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "text-large fw-bold mr-3" }
const _hoisted_3 = {
  key: 0,
  class: "section-sport d-flex align-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_5 = { class: "me-2 fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right p-0 mx-3 text-black" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "me-2 fw-bold" }, "Nominal", -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-12 col-md-6 col-lg-3" }
const _hoisted_10 = { class: "sticky-lg-top" }
const _hoisted_11 = { class: "col-sm-12 col-md-6 col-lg-9" }
const _hoisted_12 = { class: "card card-custom mb-4" }
const _hoisted_13 = { class: "card-header flex-wrap px-3" }
const _hoisted_14 = { class: "card-title" }
const _hoisted_15 = { class: "card-toolbar" }
const _hoisted_16 = { class: "d-flex align-items-center mr-4 gap-4" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "fa fa-cog fa-spin text-white ms-2 fs-2 p-0"
}
const _hoisted_19 = {
  key: 1,
  class: "bi bi-cloud-arrow-down-fill text-white ms-2 fs-1 me-0 p-0"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle-fill text-primary ms-3" }, null, -1)
const _hoisted_21 = { class: "card card-custom" }
const _hoisted_22 = { class: "card-header flex-wrap px-3" }
const _hoisted_23 = { class: "card-title" }
const _hoisted_24 = { class: "card-toolbar" }
const _hoisted_25 = { class: "me-2 fw-bolder" }
const _hoisted_26 = {
  class: "",
  style: {"line-height":"1.25"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "d-flex align-items-center text-hover-primary cursor-pointer" }
const _hoisted_29 = { class: "symbol symbol-30 symbol-light-success me-3" }
const _hoisted_30 = {
  class: "text-dark-50",
  style: {"line-height":"1.25"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_33 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_34 = {
  key: 0,
  class: "bi bi-check2 text-primary fs-2"
}
const _hoisted_35 = {
  key: 1,
  class: "bi bi-x-circle text-danger fs-2"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_MixedWidget1 = _resolveComponent("MixedWidget1")!
  const _component_MixedWidget14 = _resolveComponent("MixedWidget14")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ModalSelectPerson = _resolveComponent("ModalSelectPerson")!
  const _component_ModalRegister = _resolveComponent("ModalRegister")!
  const _component_ModalTest = _resolveComponent("ModalTest")!
  const _component_ModalTeamColor = _resolveComponent("ModalTeamColor")!
  const _component_ModalObservaciones = _resolveComponent("ModalObservaciones")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_sFiles = _resolveComponent("sFiles")!
  const _component_ModalTenisMesa = _resolveComponent("ModalTenisMesa")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogNominal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogNominal) = $event)),
      fullscreen: true,
      class: "bg-light",
      onOpened: _ctx.onOpened,
      onClosed: _ctx.onClosed
    }, {
      header: _withCtx(({}) => [
        _createVNode(_component_el_page_header, {
          icon: _ctx.ArrowLeft,
          onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogNominal = false))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_avatar, {
                size: 32,
                class: "me-3",
                src: _ctx.evento.logo
              }, null, 8, ["src"]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.evento.name), 1),
              (_ctx.sport?.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.sport.name), 1),
                    _hoisted_6,
                    _hoisted_7,
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: `Inscripciones ${_ctx.closure?.mstatus == 'O' ? 'habilitadas' : 'finalizadas'}`,
                      placement: "right"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.sport?.name)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(`bg-${_ctx.closure?.mstatus == 'O' ? 'success pulse-success' : 'danger pulse-danger'} rounded-circle border border-2 border-white h-20px w-20px`)
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.closure?.dscount == 1)
                ? (_openBlock(), _createBlock(_component_CountDown, {
                    key: 0,
                    fechafin: _ctx.closure?.date_end,
                    "class-name": "text-center border rounded bg-success h6 fw-normal text-white",
                    "class-text": "mb-0 fw-bolder",
                    subtitle: "font-size:10px;",
                    dangerClass: "mb-2"
                  }, null, 8, ["fechafin"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_scrollbar, {
                height: `${_ctx.altura+95}px`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_MixedWidget1, {
                    "widget-classes": "card-xl-stretch mb-xl-4",
                    "widget-color": "primary",
                    loading: _ctx.loaderSumary,
                    "widget-title": _ctx.t('acrd9'),
                    "widget-amount": _ctx.total,
                    "items-list": _ctx.listRCheckDoc,
                    "items-two": _ctx.listRGender
                  }, null, 8, ["loading", "widget-title", "widget-amount", "items-list", "items-two"]),
                  _createVNode(_component_MixedWidget14, {
                    "widget-classes": "card-xxl-stretch mb-4 mb-xl-6",
                    "widget-color": "#d9f5f8",
                    loading: _ctx.loaderSumary,
                    title: _ctx.t('acrd10'),
                    items: _ctx.listRTRegister
                  }, null, 8, ["loading", "title", "items"])
                ]),
                _: 1
              }, 8, ["height"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.tregister,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tregister) = $event)),
                    onChange: _ctx.getListNominal,
                    class: "me-3"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSetting.tregister, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_radio_button, {
                          key: `erb-${index}`,
                          label: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_el_button, {
                      onClick: _ctx.openTenisMesa,
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Modalidades")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_ctx.closure?.mstatus == 'O')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_el_button, {
                            color: "#626aef",
                            onClick: _ctx.sendDataValidation
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('end')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "success",
                            class: "me-3",
                            onClick: _ctx.openModalSelectPersons
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('register')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_dropdown, null, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              command: "a",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'nominal', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: '',
                                                d: _ctx.listChecks
                                            })))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ficha Nominal")
                              ]),
                              _: 1
                            }),
                            (_ctx.sport.categorie == 1)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 0,
                                  command: "a",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'auxiliar', {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: '',
                                                d: _ctx.listChecks
                                            })))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Ficha Auxiliar "),
                                    _createVNode(_component_el_tooltip, {
                                      class: "box-item",
                                      effect: "dark",
                                      content: "Descargar y presentar un dia antes del inicio de la competencia",
                                      placement: "right"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_20
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.sport?.fnc == 1)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 1,
                                  command: "a",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', `nominal/${_ctx.sport.slug}`, {
                                                a: _ctx.mbtoa(_ctx.evento.idevent),
                                                b: _ctx.mbtoa(_ctx.sport.idsport),
                                                c: '',
                                                d: _ctx.listChecks
                                            })))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Nominal de competencia ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          class: "me-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('download')) + " ", 1),
                            (_ctx.loaderDownload)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                              : (_openBlock(), _createElementBlock("i", _hoisted_19))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchText,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchText) = $event)),
                    placeholder: _ctx.t('search'),
                    "prefix-icon": _ctx.Search,
                    clearable: "",
                    class: "w-300px me-3"
                  }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t('state')), 1),
                  _createVNode(_component_el_select, {
                    class: "w-200px",
                    modelValue: _ctx.listChecks,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listChecks) = $event)),
                    onChange: _ctx.getListNominal,
                    multiple: "",
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    placeholder: "Estado"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.filteredNominal,
              onSelectionChange: _ctx.handleSelectionChange,
              border: "",
              style: {"width":"100%"},
              height: _ctx.altura
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "50"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "docnumber",
                  label: _ctx.t('document'),
                  width: "120"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", null, _toDisplayString(scope.row.doc_name), 1),
                      _hoisted_27,
                      _createElementVNode("span", null, _toDisplayString(scope.row.docnumber), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "persona",
                  label: _ctx.t('participant'),
                  width: "250"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_el_avatar, {
                          shape: "square",
                          size: "default",
                          fit: "contain",
                          src: `${_ctx.repo}/uploads/${scope.row.photo}`,
                          class: _normalizeClass('border')
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("span", null, _toDisplayString(scope.row.firstname), 1),
                        _hoisted_31,
                        _createElementVNode("span", null, _toDisplayString(scope.row.lastname + ' ' + scope.row.surname), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "gender",
                  label: _ctx.t('gender'),
                  width: "80"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.gender == 'M')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(scope.row.gender), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(scope.row.gender), 1))
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "function_name",
                  label: _ctx.t('function')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: "Cred",
                  align: "center",
                  width: "70"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.credential == 1)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                      : (_openBlock(), _createElementBlock("i", _hoisted_35))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: _ctx.t('state'),
                  align: "center",
                  width: "110"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge badge-${scope.row.check_class}`)
                    }, _toDisplayString(scope.row.check_name), 3)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "created_at",
                  label: _ctx.t('registered'),
                  width: "180"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: "Op",
                  width: "150",
                  fixed: "right"
                }, {
                  default: _withCtx((scope) => [
                    ((scope.row.checkdoc == 0 || scope.row.checkdoc == 4))
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          effect: "dark",
                          content: _ctx.t('edit'),
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "bi bi-pencil-square fs-2 text-hover-primary me-4",
                              onClick: ($event: any) => (_ctx.onEdit(scope.row, 2))
                            }, null, 8, _hoisted_36)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      : _createCommentVNode("", true),
                    (scope.row.checkdoc == 0)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 1,
                          effect: "dark",
                          content: _ctx.t('delete'),
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "bi bi-trash fs-2 text-hover-danger me-4",
                              onClick: ($event: any) => (_ctx.onDelete(scope.row))
                            }, null, 8, _hoisted_37)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      : _createCommentVNode("", true),
                    (scope.row.checkdoc == 4)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 2,
                          effect: "dark",
                          content: "Ver observaciones",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "bi bi-exclamation-triangle fs-2 text-hover-danger me-4",
                              onClick: ($event: any) => (_ctx.onObservations(scope.row))
                            }, null, 8, _hoisted_38)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (_ctx.closure?.verify_test == 1)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 3,
                          effect: "dark",
                          content: "Modificar Pruebas",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "bi bi-bezier2 fs-2 text-hover-danger me-4",
                              onClick: ($event: any) => (_ctx.OnTest(scope.row))
                            }, null, 8, _hoisted_39)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    ((_ctx.closure?.verify_docs == 1))
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 4,
                          effect: "dark",
                          content: 'Ver documentación',
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "bi bi-folder-fill fs-2 text-hover-primary me-4",
                              onClick: ($event: any) => (_ctx.onViewDocumentation(scope.row))
                            }, null, 8, _hoisted_40)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (scope.row.credential == '1')
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 5,
                          effect: "dark",
                          content: 'Descargar credencial',
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "bi bi-person-vcard-fill fs-2x text-primary text-hover-success cursor-pointer",
                              onClick: ($event: any) => (_ctx.downloadCredential(scope.row))
                            }, null, 8, _hoisted_41)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "onSelectionChange", "height"])), [
              [_directive_loading, _ctx.loaderTable]
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loaderGral]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onOpened", "onClosed"]),
    _createVNode(_component_ModalSelectPerson, {
      onGetSelectRow: _ctx.getSelectRow,
      "type-register": _ctx.tregister,
      sport: _ctx.sport,
      event: _ctx.evento
    }, null, 8, ["onGetSelectRow", "type-register", "sport", "event"]),
    _createVNode(_component_ModalRegister, {
      evento: _ctx.evento,
      sport: _ctx.sport,
      setting: _ctx.listSetting,
      onOnResponse: _ctx.onResponse,
      action: _ctx.action,
      "type-register": _ctx.tregister
    }, null, 8, ["evento", "sport", "setting", "onOnResponse", "action", "type-register"]),
    _createVNode(_component_ModalTest),
    _createVNode(_component_ModalTeamColor),
    _createVNode(_component_ModalObservaciones, { idacrd: _ctx.rowIdObs }, null, 8, ["idacrd"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogTerminos,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogTerminos) = $event)),
      title: "Declaración jurada",
      draggable: "",
      top: "0vh",
      onClosed: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isTerminos = false))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_43, [
          _createVNode(_component_el_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogTerminos = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancelar")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: !_ctx.isTerminos,
            onClick: _ctx.sendVerification
          }, {
            default: _withCtx(() => [
              _createTextVNode("Enviar inscripción")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          height: _ctx.altura <= 500 ? '500px' : _ctx.altura + 'px'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "px-8 h-100",
              innerHTML: _ctx.evento.tennor,
              width: "100%"
            }, null, 8, _hoisted_42)
          ]),
          _: 1
        }, 8, ["height"]),
        _createVNode(_component_el_checkbox, {
          class: "mt-4",
          modelValue: _ctx.isTerminos,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isTerminos) = $event)),
          label: "Declaro que he leído y comprendido la presente declaración jurada en su totalidad.",
          size: "large"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogDocumentation,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogDocumentation) = $event)),
      title: "Documentación",
      draggable: "",
      top: "0vh",
      onClosed: _ctx.onClosedDoc,
      width: "80%"
    }, {
      default: _withCtx(() => [
        (_ctx.rowAcrd?.idacreditation)
          ? (_openBlock(), _createBlock(_component_sFiles, {
              key: 0,
              idacrd: _ctx.rowAcrd?.idacreditation,
              target: 'accreditation'
            }, null, 8, ["idacrd"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"]),
    _createVNode(_component_ModalTenisMesa, {
      ref: "ModalTenisMesaRef",
      evento: _ctx.evento,
      sport: _ctx.sport,
      "list-status": _ctx.listStatus,
      closure: _ctx.closure
    }, null, 8, ["evento", "sport", "list-status", "closure"])
  ], 64))
}